import { Box, Typography, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import NavGroup from './nav-components/NavGroup';
import Socials from './nav-components/Socials';
import navItemList from '../global/navItemList';
import { useNavigate } from 'react-router';
import { tokens } from '../theme/theme';
import BoltIcon from '@mui/icons-material/Bolt';

const Sidebar = ({ location, onLocationChange, variant, onVariantChange }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const [currentRoute, setCurrentRoute] = useState(location);

  useEffect(() => {
    setCurrentRoute(location);
  }, [location]);

  const navigate = useNavigate();

  function handleLogoLocation() {
    navigate('/');
    onLocationChange('/');
  }

  const isBauwesen = variant === 'bauwesen';

  function handleVariantChange(newVariant, path) {
    onLocationChange(path);
    navigate(path);
    onVariantChange(newVariant);
  }

  return (
    <Box
      className="hidden md:flex h-full flex-col gap-6 pb-8 overflow-y-auto"
      sx={{ width: '400px' }}
    >
      <Box className="p-8 flex flex-col gap-4">
        <img
          onClick={handleLogoLocation}
          src="/media/logo.svg"
          className="w-full cursor-pointer"
        />

        <Typography variant="h4">
          Heimathafen für Ihren Projekterfolg
        </Typography>
      </Box>
      <Box
        onClick={() =>
          handleVariantChange(
            isBauwesen ? 'energieberatung' : 'bauwesen',
            isBauwesen ? 'energie-experte' : '/'
          )
        }
        className="flex flex-row justify-start items-center gap-1 relative pl-4 py-1 text-md uppercase font-medium cursor-pointer mx-4"
        sx={{
          '::before': {
            position: 'absolute',
            left: '0',
            content: '" "',
            backgroundColor: isBauwesen
              ? colors.energy[500]
              : colors.highlight[500],
            height: '100%',
            width: '4px',
            opacity: '1',
            transform: 'translateX(0px)',
            transition: '0.3s',
            transitionDelay: '0.05s',
          },
          ':hover::before': {
            opacity: '1',
            width: '4px',
            transform: 'translateX(0px)',
          },
        }}
      >
        {isBauwesen ? (
          <BoltIcon sx={{ color: colors.energy[500] }} />
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="21"
            viewBox="0 0 18.537 21.05"
          >
            <g
              id="V2_Bauzaun"
              data-name="V2 Bauzaun"
              transform="translate(-0.002)"
            >
              <g id="icons" transform="translate(0.002)">
                <g id="Fachbauleitung" transform="translate(0)">
                  <g id="Gruppe_2" data-name="Gruppe 2">
                    <path
                      id="Pfad_1"
                      data-name="Pfad 1"
                      d="M10.029,0a1.281,1.281,0,0,1,.959.709,4.314,4.314,0,0,1,.155.514c.258.014.531.018.8.045A1.786,1.786,0,0,1,13.559,2.91a.523.523,0,0,0,.3.465,6.813,6.813,0,0,1,3.371,5.1c.009.063.016.125.026.187a.382.382,0,0,0,.032.067c.179,0,.373,0,.566,0a.641.641,0,0,1,.681.689c0,.73-.007,1.46,0,2.19a.771.771,0,0,1-.347.745c.095.282.207.547.273.823a2.447,2.447,0,0,1-2.007,2.909,2.64,2.64,0,0,1-.461.036.227.227,0,0,0-.266.192,6.273,6.273,0,0,1-1.445,2.516A6.6,6.6,0,0,1,8.4,20.99a6.583,6.583,0,0,1-4.671-2.817,6.019,6.019,0,0,1-.906-1.82.267.267,0,0,0-.3-.234,2.47,2.47,0,0,1-2.5-2.234A2.369,2.369,0,0,1,.274,12.58c.03-.063.062-.125.1-.21-.369-.2-.381-.545-.375-.908.011-.674,0-1.348,0-2.022a.647.647,0,0,1,.7-.71c.182,0,.364,0,.562,0,.035-.217.06-.425.1-.629A6.8,6.8,0,0,1,4.811,3.3a.3.3,0,0,0,.158-.287,1.8,1.8,0,0,1,1.382-1.7,2.987,2.987,0,0,1,.583-.07c.153-.011.307,0,.474,0,.017-.078.032-.144.045-.211A1.2,1.2,0,0,1,8.332.054L8.513,0H10.03ZM3.706,12.432c0,.47-.015.919,0,1.366a10.377,10.377,0,0,0,.118,1.57,5.551,5.551,0,0,0,10.973-.6c.055-.755.024-1.515.032-2.273a.251.251,0,0,0-.023-.066H3.706ZM4.965,4.667a5.507,5.507,0,0,0-2.428,4.05H16.01c.018-1.321-1.375-3.644-2.428-4.033,0,.153,0,.3,0,.444s0,.3,0,.442a.6.6,0,0,1-.679.585.622.622,0,0,1-.536-.673c0-.786,0-1.573,0-2.359a.6.6,0,0,0-.493-.64,6.367,6.367,0,0,0-.751-.006v.238c0,.506.006,1.011,0,1.517a.961.961,0,0,1-.093.4.584.584,0,0,1-.649.279.594.594,0,0,1-.469-.6c0-.962-.006-1.924,0-2.886,0-.171-.052-.219-.215-.211a7.132,7.132,0,0,1-.779,0c-.205-.013-.276.038-.273.262.015.926.007,1.854.005,2.78a.607.607,0,0,1-.6.666.613.613,0,0,1-.612-.662c0-.519,0-1.039,0-1.559V2.46c-.187,0-.347,0-.507,0-.505,0-.736.233-.736.733,0,.744,0,1.488,0,2.233a1.108,1.108,0,0,1-.051.351.593.593,0,0,1-.639.376.586.586,0,0,1-.519-.55c-.015-.305,0-.612,0-.937ZM1.237,11.185H17.305v-.942a.26.26,0,0,0-.292-.3H1.529a.438.438,0,0,0-.166.005c-.05.023-.118.079-.119.123-.01.364-.005.728-.005,1.111ZM2.49,12.418a1.234,1.234,0,0,0-1.066.6,1.175,1.175,0,0,0,.031,1.328,1.169,1.169,0,0,0,1.035.545V12.418Zm13.562,2.465a1.221,1.221,0,1,0,0-2.44v2.44Z"
                      transform="translate(-0.002)"
                      fill="#c34237"
                    />
                  </g>
                </g>
              </g>
            </g>
          </svg>
        )}
        {isBauwesen ? 'Energieberatung' : 'Tiefbauarbeiten'}
      </Box>
      <Box className="flex flex-col justify-between px-4 h-full">
        {navItemList[variant]?.map((group, index) => (
          <NavGroup
            key={index}
            group={group}
            location={currentRoute}
            onLocationChange={onLocationChange}
            color={isBauwesen ? colors.highlight[500] : colors.energy[500]}
          />
        ))}
      </Box>
      <Socials
        color={isBauwesen ? colors.highlight[500] : colors.energy[500]}
      />
    </Box>
  );
};

export default Sidebar;
